import { defineAction } from '~/prix'
import { z } from 'zod'
import { creditDocumentStatus } from '../creditDocumentObject'
import creditDocumentConfirmAction from './creditDocumentConfirm.action.json' with { type: 'json' }

const creditDocumentConfirmDefinition = defineAction({
  ...creditDocumentConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: creditDocumentStatus,
  }),
  output: z.object({}),
})

export default creditDocumentConfirmDefinition
